import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveInactiveFor, CreditType, InteractionType, LocalService, PageKey, RelationshipInitialization, RelationShipRole, Status, SummaryType, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { CreditLogsComponent } from '../../popups/credit-logs/credit-logs.component';
import { EditCreditsComponent } from '../../popups/edit-credits/edit-credits.component';
import { EditRelationshipComponent } from '../../popups/edit-relationship/edit-relationship.component';
import { EditAdditionalDetailsComponent } from 'src/app/popups/edit-additional-details/edit-additional-details.component';

@Component({
  selector: 'app-relationships',
  templateUrl: './relationships.component.html',
  styleUrls: ['./relationships.component.scss']
})
export class RelationshipsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["relationship"]; maxBodyHeight = 0;
  wrapperInitialization: RelationshipInitialization; isShowRemovedRelation: boolean = false; businessId = '';
  ctryCode: string = ''; interactionType: InteractionType = InteractionType.None; userId = '';
  RelationShipRole = RelationShipRole;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private profileManagementService: ProfileManagementService, private modalService: NgbModal, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.ctryCode = routeParams.ctryCode;
      this.userId = routeParams.userId;
      this.businessId = routeParams.businessId;
      if (this.interactionType == InteractionType.Business || this.interactionType == InteractionType.Bill_PnixSoft)
        this.configurationManagementService.ensurePageActions(PageKey.RelationShipsBusiness, this.businessId);
      else if (this.interactionType == InteractionType.ServiceProvider)
        this.configurationManagementService.ensurePageActions(PageKey.RelationShipsServiceProvider);
      else
        this.configurationManagementService.ensurePageActions(PageKey.RelationShips);
      if (this.interactionType == InteractionType.Business && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else if (this.interactionType == InteractionType.ServiceProvider && (this.businessId == '' || this.businessId == '0')) {
        this.localService.onDirectToServiceProviderCreation();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(10);
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.profileManagementService.getRelationshipInitialization(this.businessId).subscribe(result => {
        if (result) {
          this.wrapperInitialization = result;
          this.wrapperInitialization.roles.find(x => x.key == "0").value = this.localService.languageContent.common.all;
        }
      });
    }
  }

  getRole(enumId) {
    return this.wrapperInitialization.roles.find(x => x.key == enumId).value;
  }

  isProcessing = false;
  onLoadItems() {
    if (!this.isProcessing) {
      this.isProcessing = true;
      this.profileManagementService.getRelationships(this.businessId, this.isShowRemovedRelation, this.wrapperInitialization.selectedRole, this.wrapperInitialization.contents.paging).subscribe(result => {
        this.wrapperInitialization.contents = result;
        this.isProcessing = false;
      });
    }
  }

  onToggleCheckbox(index: number) {
    this.isShowRemovedRelation = !this.isShowRemovedRelation;
    this.onLoadItems();
  }

  onSelectDropDown(index: number) {
    this.onLoadItems();
  }

  onRemoveOrUndo(relationShipId: string) {
    this.profileManagementService.activeInactiveStatus(relationShipId, ActiveInactiveFor.Relationship).subscribe(result => {
      if (result.status == Status.Success) {
        this.wrapperInitialization.contents.items = this.wrapperInitialization.contents.items.filter(x => x.key != relationShipId);
      }
    });
  }

  onEdit(relationShipId: string, index: number) {
    switch (index) {
      case 1: {
        const modalRef = this.modalService.open(EditRelationshipComponent, { ariaLabelledBy: 'modal-basic-title' });
        modalRef.componentInstance.id = relationShipId;
        modalRef.componentInstance.roles = this.wrapperInitialization.roles;
        modalRef.componentInstance.enumId = this.wrapperInitialization.contents.items.find(x => x.key == relationShipId).v4;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.wrapperInitialization.contents.items.find(x => x.key == relationShipId).v4 = result.enumId;
          }
        });
      } break;
      case 2: {
        const modalRef = this.modalService.open(EditCreditsComponent, { ariaLabelledBy: 'modal-basic-title' });
        modalRef.componentInstance.id = relationShipId;
        modalRef.componentInstance.creditType = CreditType.Manual;
        modalRef.componentInstance.currentCredits = this.wrapperInitialization.contents.items.find(x => x.key == relationShipId).v6;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.wrapperInitialization.contents.items.find(x => x.key == relationShipId).v6 = result.currentCredits;
          }
        });
      } break;
    }
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        const modalRef = this.modalService.open(EditAdditionalDetailsComponent);
        modalRef.componentInstance.id = key;
        modalRef.componentInstance.ctryCode = this.ctryCode;
        modalRef.result.then((result) => {
          // if (result.event == TriggeredEvent.Ok) {
          //   this.onLoad();
          // }
        });
      } break;
    }
  }

  onShowHistory(relationShipId: string) {
    const modalRef = this.modalService.open(CreditLogsComponent);
    modalRef.componentInstance.id = relationShipId;
    modalRef.componentInstance.interactionType = this.interactionType;
    modalRef.componentInstance.ctryCode = this.ctryCode;
    modalRef.componentInstance.userId = this.userId;
  }

  onGetSummaryType(strRelationShipRole: string, strRelationShipType: string): SummaryType {
    let relationShipRole: RelationShipRole = parseInt(strRelationShipRole);
    let relationShipType: InteractionType = parseInt(strRelationShipType);
    return this.interactionType == InteractionType.User || relationShipRole == RelationShipRole.Business ? (relationShipType == InteractionType.Business ? SummaryType.Business : SummaryType.ServiceProvider) : SummaryType.User;
  }

  onGetSummaryParentId(businessId: string, userId: string): string {
    return this.interactionType == InteractionType.Business || this.interactionType == InteractionType.ServiceProvider ? businessId : userId;
  }

  onGetIcon(strRelationShipRole: string, strRelationShipType: string): string {
    let summaryType = this.onGetSummaryType(strRelationShipRole, strRelationShipType);
    let iconName = '';
    switch (summaryType) {
      case SummaryType.User: {
        iconName = 'person';
      } break;
      case SummaryType.Business: {
        iconName = 'domain';
      } break;
      case SummaryType.ServiceProvider: {
        iconName = 'home_repair_service';
      } break;
    }
    return iconName;
  }
}
